import { Link } from "react-router-dom";
import { Mail, Phone, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { openCookieSettings } from "./GdprPopup";
import { useLang } from "../../lib/i18n";
import { useContent } from "../../lib/useFetch";

export const Footer = () => {
  const { t, trc } = useLang();
  const c = useContent();
  const site = c.site?.fields || {};
  return (
    <footer className="relative overflow-hidden bg-[#0A2540] text-white" data-testid="site-footer">
      <div className="container-x grid gap-12 py-16 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo light vertical />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">{trc(c, "home", "services_text")}</p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-4">Atlantis</p>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/about" className="hover:text-white">{t("nav_about")}</Link></li>
            <li><Link to="/clinics" className="hover:text-white">{t("nav_clinics")}</Link></li>
            <li><Link to="/partners" className="hover:text-white">{t("nav_partners")}</Link></li>
            <li><Link to="/contacts" className="hover:text-white">{t("nav_contacts")}</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow mb-4">{t("nav_contacts")}</p>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-center gap-2"><Mail size={16} className="text-[#00A8B5]" /><a href={`mailto:${site.email}`}>{site.email}</a></li>
            <li className="flex items-center gap-2"><Phone size={16} className="text-[#00A8B5]" />{site.head_coach} · {site.phone}</li>
            <li className="flex items-center gap-2"><MessageCircle size={16} className="text-[#00A8B5]" /><a href={site.whatsapp_url} target="_blank" rel="noreferrer" className="hover:text-white">{t("whatsapp")}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">© {new Date().getFullYear()} Atlantis Academy · {site.tagline} · <Link to="/privacy" className="underline hover:text-white" data-testid="footer-privacy-link">{trc(c, "gdpr", "policy_link_label") || "Privacy Policy"}</Link> · {(c.gdpr?.fields?.show_popup || "").toLowerCase() !== "no" && <button onClick={openCookieSettings} className="underline hover:text-white" data-testid="footer-cookie-settings">{trc(c, "gdpr", "settings_link_label") || "Cookie settings"}</button>}</div>
    </footer>
  );
};
